/**
 * Carrega o SDK oficial (MercadoPago.js v2). O Mercado Pago exige que seja carregado do domínio deles
 * (não pode ser empacotado): é o que garante que os dados do cartão nunca passem pelo Garlic.
 */
type BrickController = { unmount: () => void };
type MercadoPagoCtor = new (publicKey: string, opts: { locale: string }) => {
  bricks: () => { create: (kind: 'cardPayment', container: string, settings: unknown) => Promise<BrickController> };
};
declare global {
  interface Window {
    MercadoPago?: MercadoPagoCtor;
    MP_DEVICE_SESSION_ID?: string;
  }
}

let loading: Promise<MercadoPagoCtor> | null = null;

export function loadMercadoPago(): Promise<MercadoPagoCtor> {
  if (window.MercadoPago) return Promise.resolve(window.MercadoPago);
  loading ??= new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://sdk.mercadopago.com/js/v2';
    s.async = true;
    s.onload = () => (window.MercadoPago ? resolve(window.MercadoPago) : reject(new Error('SDK do Mercado Pago indisponível')));
    s.onerror = () => {
      loading = null;
      reject(new Error('Não foi possível carregar o pagamento com cartão. Verifique sua conexão.'));
    };
    document.head.appendChild(s);
  });
  return loading;
}

export type CardFormData = {
  token: string;
  issuer_id?: string;
  payment_method_id: string;
  transaction_amount: number;
  installments: number;
  payer: { email: string; identification?: { type: string; number: string } };
};
